const cssvh = (percent: number) => {
  const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return (percent * h) / 100;
};

const cssvw = (percent: number) => {
  const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  return (percent * w) / 100;
};

export const vh = (val: number, base = 1080): number => {
  return cssvh((val / base) * 100);
};

export const vw = (val: number, base = 375): number => {
  return cssvw((val / base) * 100);
};

export const vw_d = (val: number, base = 640): number => {
  return cssvw((val / base) * 100);
};

export function vw_dSizes(num: number) {
  return (num / 680) * 100;
}

export function vwSizes(num: number) {
  return (num / 343) * 100;
}
